export default "__VITE_ASSET__ZG4yM9iF__"